import { Link } from "react-router-dom";
import BrandMark from "./BrandMark";

// Single flat link list — same order as the navbar. No section headers, no
// duplicates, all anchors verified to point at real ids on the homepage.
const footerLinks = [
  { label: "Meet the Expert",     to: "/#about" },
  { label: "The Process",         to: "/#how-it-works" },
  { label: "Who We Help",         to: "/#who-we-help" },
  { label: "Ready When You Are",  to: "/#get-started" },
  { label: "Client Stories",      to: "/#stories" },
  { label: "The Technology",      to: "/#tech" },
  { label: "Referral Network",    to: "/#referrals" },
];

export default function Footer() {
  return (
    <footer className="bg-card border-t border-border" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-10 md:gap-16">
          <div>
            <div className="mb-4">
              <BrandMark className="h-9" />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-md">
              Data-driven neuromuscular performance training. Move better. Train smarter. Recover faster.
            </p>
          </div>

          <nav aria-label="Footer navigation" className="flex flex-col gap-2.5 md:items-end">
            {footerLinks.map((l) => (
              <a key={l.label} href={l.to} className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                {l.label}
              </a>
            ))}
            <Link to="/book" className="text-sm text-[#007AFF] hover:text-[#3395FF] font-medium transition-colors" data-testid="footer-link-get-started">
              Get Started →
            </Link>
          </nav>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">&copy; {new Date().getFullYear()} Fit Fusion Analytics. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <p className="text-xs text-muted-foreground">Move Better. Train Smarter. Recover Faster.</p>
            <span className="text-xs text-muted-foreground/40">·</span>
            <Link
              to="/login"
              className="text-xs text-muted-foreground/60 hover:text-[#007AFF] transition-colors"
              data-testid="footer-admin-link"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
